export enum ActionType {
  BESTODDS = "SET_SHOW_BEST_ODDS",
  ACTIVE_BOOKMAKER = "SET_ACTIVE_BOOKMAKER",
  ACTIVE_BOOKMAKER_NAME = "SET_ACTIVE_BOOKMAKER_NAME",
  ACTIVE_ODDS_FORMAT = "SET_ACTIVE_ODDS_FORMAT",
  BEST_ODDS = "SET_BEST_ODDS",
}

export interface ShowBestOddsAction {
  type: ActionType.BESTODDS;
  payload: boolean;
}

export interface ActiveBookmakerAction {
  type: ActionType.ACTIVE_BOOKMAKER;
  payload: string;
}

export interface ActiveBookmakerNameAction {
  type: ActionType.ACTIVE_BOOKMAKER_NAME;
  payload: string;
}

export interface ActiveOddsFormatAction {
  type: ActionType.ACTIVE_ODDS_FORMAT;
  payload: string;
}

export interface SetBestODdsAction {
  type: ActionType.BEST_ODDS;
  payload: object;
}

export type Action =
  | ShowBestOddsAction
  | ActiveBookmakerAction
  | ActiveBookmakerNameAction
  | ActiveOddsFormatAction
  | SetBestODdsAction;

export interface BestOdds {
  odds: string;
  oddsAmerican: string;
  oddsDecimal: number;
}

export interface ReducerState {
  showBestOdds: boolean;
  activeBookmaker: string;
  activeBookmakerName: string;
  bestOdds: BestOdds;
}
